import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataFormatService {
    constructor() { }

    /**
     * Sorting the input collection by specific property 
     */

    sortByProperty<T>(list: T[], prop: string) {
        return list?.sort((index1, index2) => {
            const f = (Reflect.get(index1 as object, prop) as string | undefined)?.toLowerCase();
            const s = (Reflect.get(index2 as object, prop) as string | undefined)?.toLowerCase();
            return (f! < s!) ? -1 : (f! > s!) ? 1 : 0;
        })
    }
    
}